module.exports = __webpack_public_path__ + "static/media/swings.0caed2cd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/swings.jpeg
// module id = 236
// module chunks = 0